import find from 'lodash/find'

export const getHtmlCopy = (obj, key) => {
  return getCopy(obj, key, true)
}

export const getTextCopy = (obj, key) => {
  return getCopy(obj, key, false)
}

export const getCopy = (obj, key, html = true) => {
  let pageContent = find(obj, {key: key})?.value

  if (!pageContent) {
    throw Error('Unknown Page Content key: "' + key + '"')

  }

  switch (pageContent.__typename) {
    case `ContentfulMicrocopy`:
      return pageContent.value
    case `ContentfulMacrocopy`:
      return html ? pageContent.markdown.child.html : pageContent.markdown.child.text
    default:
      throw Error('Unsupported Page Content type: "' + pageContent.__typename + '" on key "' + key + '"')
  }
}

export const getLinkPath = (link) => {
  switch (link.__typename) {
    case `ContentfulPage`:
      return link.slug
    case `ContentfulArticle`:
      return `/learn/${link.slug}/`
    case `ContentfulCaseStudy`:
      return `/work/${link.slug}/`
    default:
      throw Error('Unsupported link type: "' + link.__typename)
  }
}
